export const PUBLIC_PAD_ID = "public";
export const MAX_FILE_BYTES = 25 * 1024 * 1024;
export const MAX_TEXT_CHARS = 1_000_000;

export interface PadFile {
  id: string;
  name: string;
  type: string;
  size: number;
  key: string;
  uploadedAt: number;
}

export interface PublicPadFile {
  id: string;
  name: string;
  type: string;
  size: number;
  uploadedAt: number;
  downloadUrl: string;
}

export interface PadState {
  id: string;
  text: string;
  version: number;
  updatedAt: number;
  files: PublicPadFile[];
}

export type ClientMessage =
  | {
      type: "set_text";
      text: string;
    }
  | {
      type: "ping";
    };

export type ServerMessage =
  | {
      type: "state";
      state: PadState;
    }
  | {
      type: "presence";
      clients: number;
    }
  | {
      type: "error";
      message: string;
    }
  | {
      type: "pong";
    };

export function toPublicFile(padId: string, file: PadFile): PublicPadFile {
  return {
    id: file.id,
    name: file.name,
    type: file.type,
    size: file.size,
    uploadedAt: file.uploadedAt,
    downloadUrl: `/api/pads/${encodeURIComponent(padId)}/files/${encodeURIComponent(file.id)}/download`,
  };
}

export function isValidPadId(value: string): boolean {
  return /^[A-Za-z0-9_-]{1,64}$/.test(value);
}

export function normalizePadId(value: string | null | undefined): string | null {
  if (!value || value === PUBLIC_PAD_ID) {
    return PUBLIC_PAD_ID;
  }
  return isValidPadId(value) ? value : null;
}
